<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDoubleRight,
} from '@fortawesome/pro-regular-svg-icons';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';

library.add(
  faAngleDoubleRight,
);

export default {
  props: {
    matches: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    EsHeader,
    EsLoader,
  },
};
</script>

<template>
  <div class="document">
    <div class="header">
      <es-header>
        <template #header>
          <div class="header-title">
            Pending Near Matches
          </div>
          <div class="header-subtitle">5 Most Recent Near Matches</div>
        </template>
        <template #actions>
            <ul>
              <li class="p-narrow no-border">
                  <div class="list-content">
                    <router-link
                      :to="{
                        name: 'nearMatches',
                      }"
                    >
                      <font-awesome-icon
                        :icon="['far', 'angle-double-right']"
                        class="fa-2x"
                        title="View Pending Near Matches"
                      />
                    </router-link>
                  </div>
              </li>
            </ul>
        </template>
      </es-header>
    </div>
    <div class="content">
      <es-loader v-if="this.loading"/>

      <table v-else class="table-layout--fixed">
        <tbody>
          <tr v-for="(match, index) in matches" :key="index">
            <td class="single-row--summary">
              <span>{{ match.id }} - </span>
              <span class="has-text-weight-bold">
                {{ match.locationMatchTransDetail.request.location.name }}
              </span>
              <span class="is-italic has-text-grey">
                ({{ match.locationMatchTransDetail.request.locationOrganization.localCode }})
              </span>
              <span>{{ match.locationMatchTransDetail.request.location.street1 }},</span>
              <span v-if="match.locationMatchTransDetail.request.location.street2">
                {{ match.locationMatchTransDetail.request.location.street2 }},
              </span>
              <span>
                {{ match.locationMatchTransDetail.request.location.city }},
                {{ match.locationMatchTransDetail.request.location.stateCode }},
                {{ match.locationMatchTransDetail.request.location.zip}}
              </span>
            </td>
            <td class="action-column">
              <router-link
                :to="{
                  name: 'nearMatches',
                  params: { nearMatchId: match.id }
                }"
              >
                <font-awesome-icon
                  :icon="['far', 'angle-double-right']"
                  class="fa-2x"
                  title="View Pending Near Match"
                />
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<style lang="sass" scoped>
  table
    font-size: 12px
  .action-column
    width: 30px
    vertical-align: middle
  .single-row--summary
    overflow: hidden
    white-space: nowrap
    text-overflow: ellipsis
</style>
